import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_PRE001_Request as IndicationRequest,
  IAPI_PRE001_Response as IndicationResponse,
  IAPI_CON001_Request as ReferenceRequest,
  IAPI_CON001_Response as ReferenceResponse,
} from "../../../type/apiType";

// 掛金届出状況一覧表示
// API仕様書_掛金

const httpAPI_PRE001 = async (
  param: IndicationRequest
): Promise<IndicationResponse> => {
  let res = await http.post(ApiUrl.API_PRE001, {
    ...param,
  });
  return res.data;
};

// 契約者一覧参照API
// API仕様書_契約者

const httpAPI_CON001 = async (
  param: ReferenceRequest
): Promise<ReferenceResponse> => {
  let res = await http.post(ApiUrl.API_CON001, {
    ...param,
  });

  return res.data;
};

export { httpAPI_PRE001, httpAPI_CON001 };
